<span
  #rootElement
  [attr.readonly]="readonly()"
  [attr.tabindex]="disabled || isAutocomplete() ? -1 : 0"
  [class.active]="isFocused()"
  [class.myre-form__select]="isSelectable() || isAutocomplete()"
  [ngStyle]="elementStyle()"
  [ngClass]="elementStyleClass()"
  (click)="$event.stopPropagation()"
>
  @switch (type()) {
    @case ('autocomplete') {
      <span
        #fieldElement
        [attr.readonly]="readonly()"
        class="myre-form__field autocomplete"
        [class.focus]="isFocused()"
        [class.stretch]="stretch() && !isDesktop"
        [class.tertiary]="subTheme() === 'tertiary'"
        [class.secondary]="subTheme() === 'secondary'"
        [ngStyle]="labelStyle()"
        [ngClass]="labelStyleClass()"
      >
        <span class="left">
          @if (
            autocompleteKeep() &&
            autocompleteKeepValue() &&
            autocompleteKeepValue().label
          ) {
            <span class="myre-tag-tertiary">
              <span
                ellipsis
                [style.max-width.px]="fieldElement.clientWidth / 3"
              >
                {{ autocompleteKeepValue().label | translate }}
              </span>

              @if (!readonly() && !required()) {
                <span (click)="select(null)" class="delete">×</span>
              }
            </span>
          }

          @if (picto()) {
            <i class="{{ picto() }}"></i>
          }
        </span>

        <input
          #inputElement
          type="text"
          [disabled]="disabled"
          [readonly]="readonly()"
          [attr.tabindex]="disabled ? -1 : 0"
          [placeholder]="_getPlaceholder() | translate"
          [class.tertiary]="subTheme() === 'tertiary'"
          [class.secondary]="subTheme() === 'secondary'"
          [@stretch]="{
            value: stretch() ? (isFocused() ? 'long' : 'short') : undefined,
            params: { short: shortLength(), long: longLength() },
          }"
          (blur)="blur($event)"
          (focus)="focus($event)"
          (@stretch.done)="_stretchDone($event)"
          (input)="_emitOnInput($event)"
        />
        <i class="myre-icon-search"></i>
      </span>
    }
    @case ('select') {
      @let singleValue = _singleValue;

      <div
        [attr.readonly]="readonly() || disabled"
        [class.error]="error()"
        [class.focus]="isFocused()"
        [class.warning]="warning()"
        [ngStyle]="labelStyle()"
        [ngClass]="labelStyleClass()"
        class="myre-form__select__title"
        [class.null]="singleValue === null || singleValue?.value === null"
        [class.icon-only]="!placeholder() && placeholderIcon()"
        (click)="focus($event)"
      >
        @switch (theme()) {
          @case ('tag') {
            <myre-tag
              [iconClass]="
                readonly() || disabled ? '' : 'myre-icon-arrow_dropdown'
              "
              [withPadding]="true"
              [isClickable]="!readonly() && !disabled"
              [text]="selectedLabel(singleValue) || placeholder() | translate"
              [type]="subTheme() | subThemeToTagType"
            />
          }
          @case ('custom') {
            @if (selectedItemTemplate()) {
              <ng-template
                *ngTemplateOutlet="
                  selectedItemTemplate();
                  context: templateContext()
                "
              />
            }
          }
          @default {
            @if (
              selectedLabel(singleValue) || placeholder() || placeholderIcon()
            ) {
              <span
                class="ellipsis"
                [class.placeholder-icon-container]="placeholderIcon()"
                [class.placeholder]="!selectedLabel(singleValue)"
              >
                @if (placeholderIcon() && !selectedLabel(singleValue)) {
                  <i
                    class="{{ placeholderIcon() }}"
                    [class.icon-with-placeholder]="placeholder()"
                  ></i>
                }

                @if (selectedLabel(singleValue) || placeholder()) {
                  {{ selectedLabel(singleValue) || placeholder() | translate }}
                }
              </span>
            } @else {
              <ng-container *ngTemplateOutlet="emptyDefaultTemplate" />
            }

            @if (
              selectedLabel(singleValue) || placeholder() || !placeholderIcon()
            ) {
              <span>
                <i class="myre-icon-arrow_dropdown"></i>
              </span>
            }
          }
        }
      </div>
    }
    @case ('multiselect') {
      @let multipleValue = _multipleValues;

      <span
        [attr.readonly]="readonly()"
        class="myre-form__select__title"
        [class.null]="multipleValue === null"
        [class.focus]="isFocused()"
        [class.multi-select]="!selectAllLabel() || !isAllSelected"
        [class.overflow-y]="fixedHeight()"
        [class.error]="error()"
        [class.warning]="warning()"
        [class.icon-only]="!placeholder() && placeholderIcon()"
        [ngStyle]="labelStyle()"
        [ngClass]="labelStyleClass()"
        (click)="focus($event)"
      >
        @if (multipleValue.length) {
          <ng-container>
            @if (selectAllLabel() && isAllSelected) {
              <span>{{ selectAllLabel() | translate }}</span>
            } @else {
              <ng-container *ngTemplateOutlet="values" />
            }

            <ng-template #values>
              @for (val of multipleValue; track $index) {
                @if (selectedLabel(val)) {
                  <span class="myre-tag-tertiary">
                    {{ selectedLabel(val) | translate }}

                    @if (!readonly()) {
                      <span
                        class="delete"
                        [attr.tabindex]="-1"
                        (click)="tagRemoveClicked($event, val)"
                      >
                        ×
                      </span>
                    }
                  </span>
                }
              }
            </ng-template>
          </ng-container>
        } @else {
          <ng-container *ngTemplateOutlet="placeholderTemplate" />
        }

        <ng-template #placeholderTemplate>
          @if (placeholder() || placeholderIcon()) {
            <span
              class="ellipsis placeholder"
              [class.placeholder-icon-container]="placeholderIcon()"
            >
              @if (placeholderIcon()) {
                <i
                  class="{{ placeholderIcon() }}"
                  [class.icon-with-placeholder]="placeholder()"
                ></i>
              }

              @if (placeholder()) {
                {{ placeholder() | translate }}
              }
            </span>
          } @else {
            <ng-container *ngTemplateOutlet="emptyDefaultTemplate" />
          }
        </ng-template>

        @if (multipleValue.length || placeholder() || !placeholderIcon()) {
          <span>
            <i class="myre-icon-arrow_dropdown"></i>
          </span>
        }
      </span>
    }
  }
</span>

<ng-template #overlayElement>
  <div #overlayContainer class="overlay-container">
    @if (_displayOverlay()) {
      @if (asideTemplate()) {
        <div
          class="myre-form__select-wrapper m-width:full"
          [class.two-column]="asideOpen()"
        >
          <ng-container *ngTemplateOutlet="leftColumn" />
          @if (asideOpen()) {
            <div
              class="myre-form__select-aside m-flex-self:stretch m-min-width:11 m-overflow-y:auto"
            >
              <ng-container [ngTemplateOutlet]="asideTemplate()" />
            </div>
          }
        </div>
      } @else {
        <ng-container *ngTemplateOutlet="leftColumn" />
      }
    }
  </div>
</ng-template>

<ng-template #leftColumn>
  <div
    #scrollableContainer
    class="myre-form__select-dropdown"
    [class.myre-no-wrap]="!wrapPanel()"
    [@slide]
    (@slide.start)="_animationStart($event)"
    (@slide.done)="_animationDone()"
  >
    @if (isInputSearch()) {
      <div class="myre-form__select-search">
        <myre-textbox
          #searchInput
          picto="myre-icon-search"
          [isRightPicto]="true"
          class="myre-form__select-search__input"
          [placeholder]="searchPlaceholder() | translate"
          [(ngModel)]="_searchKeyword"
        />
      </div>
    }

    @if (headerTemplate()) {
      <ng-container [ngTemplateOutlet]="headerTemplate()" />
    }

    <ul [ngStyle]="listStyle()" [class]="listStyleClass()">
      @if (selectAllLabel() && isMultiselect()) {
        <li
          class="myre-form__select-dropdown__item"
          (click)="toggleSelectAll()"
        >
          {{ selectAllLabel() | translate }}

          <myre-checkbox
            [ngModel]="isAllSelected"
            (ngModelChange)="toggleSelectAll()"
          />
        </li>
      }
      @if (loading()) {
        <div class="myre-form__select-dropdown__item">
          <myre-dots-loader />
        </div>
      } @else {
        @for (
          item of filteredList();
          track $index;
          let index = $index;
          let first = $first;
          let last = $last
        ) {
          <li
            [class.hover]="_hoveredIndex() === index"
            [class.null]="item === null || item?.value === null"
            (click)="_selectFromList($event, index, !isMultiselect())"
            [class.disabled]="item.disabled === true"
            [attr.tabindex]="-1"
            [attr.index]="index"
            [id]="id() + '-item-' + index"
            [class.myre-form__select-dropdown__item]="!itemTemplate()"
          >
            @if (isMultiselect()) {
              <myre-checkbox
                [disabled]="item.disabled === true"
                [ngModel]="isSelected(item.value)"
                (ngModelChange)="_selectFromList(null, index)"
              />
            }

            @if (!itemTemplate()) {
              <span>
                {{ _accessor(item, key()) | translate }}
              </span>
            } @else {
              <ng-container
                [ngTemplateOutlet]="itemTemplate()"
                [ngTemplateOutletContext]="{
                  last: last,
                  first: first,
                  $implicit: item,
                  select: select.bind(this, index),
                  hovered: _hoveredIndex() === index,
                }"
              />
            }
          </li>
        } @empty {
          @if (emptyTemplate()) {
            <ng-container
              *ngTemplateOutlet="
                emptyTemplate();
                context: {
                  $implicit: filteredList(),
                  keyword: _searchKeyword(),
                  isSearching: isSearching(),
                }
              "
            />
          } @else {
            <li class="disabled myre-form__select-dropdown__item">
              {{
                (isSearching()
                  ? emptyFilteredListPlaceholder()
                  : emptyListPlaceholder()
                ) | translate
              }}
            </li>
          }
        }
      }
    </ul>

    @if (footerTemplate()) {
      <ng-container [ngTemplateOutlet]="footerTemplate()" />
    }
  </div>
</ng-template>

<ng-template #emptyDefaultTemplate>
  <span>&nbsp;</span>
</ng-template>
